import { Box, Text } from '@wix/design-system';
import React from 'react';

export interface PanelHeaderProps {
  title: string;
  subtitle?: string;
}

export function PanelHeader(props: PanelHeaderProps) {
  const { title, subtitle } = props;

  return (
    <Box padding="SP4">
      <Box direction="vertical">
        <Text size="small" weight="bold">
          {title}
        </Text>
        {subtitle && <Text size="tiny">{subtitle}</Text>}
      </Box>
    </Box>
  );
}
